<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Offline Online Revenue Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'">{{ $t("select") }} {{
                $tc("cinema", 1) }}</label>
              <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
                :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
                @input="onSelectCinema" :allowEmpty="true" :showLabels="false" :multiple="true"
                :close-on-select="false"></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"
                   @selected="onChangeDate($event, 'from')">
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="toDate"
                  v-validate="'required'" :not-after="disabledAfter" :disabledDates="disabledDates">
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("Date") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="getTotalRevenueData({ isPdf: 'N', isExcel: 'N' })">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="totalRevenueData.length > 0">
            <div class="mx-1">{{ $t("download") }} as:</div>

            <span
                @click="getTotalRevenueData({ isPdf: 'Y',isExcel:'N' })"
                title="Download as Pdf"
                style="cursor:pointer"
              >
                <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
              </span>
            <span @click="getTotalRevenueData({ isPdf: 'N', isExcel: 'Y' })" title="Download as Excel"
            style="cursor:pointer">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div v-if="totalRevenueData.length > 0" style="overflow-x: scroll; width: auto !important">
          <table class="swc-report-table" border="1" id="myTable">
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th>{{ $tc("Location") }}</th>
                <th>{{ $t("Admits Online") }}</th>
                <th>{{ $tc("Admits Offline") }}</th>
                <th>{{ $tc("Admits Total") }}</th>
                <th>{{ $t("Bo Revenue Online") }}</th>
                <th>{{ $t("Bo Revenue Offline") }}</th>
                <th>{{ $t("Bo Revenue Total") }}</th>
                <th>{{ $t("Fnb Revenue Online") }}</th>
                <th>{{ $t("Fnb Revenue Offline") }}</th>
                <th>{{ $t("Fnb Revenue Total") }}</th>
                <th>{{ $t("Total Revenue Online") }}</th>
                <th>{{ $t("Total Revenue Offline") }}</th>
                <th>{{ $t("Total Revenue") }}</th>

              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="(show, showIndex) in totalRevenueData">
                  <td class="text-left">{{ show.cinema_name  }}</td>
                  <td class="text-right">{{ show.onlineTicketAdmits || 0 }}</td>
                  <td class="text-right">{{ show.offlineTicketAdmits || 0 }}</td>
                  <td class="text-right"> {{ (show.onlineTicketAdmits || 0) + (show.offlineTicketAdmits || 0) }}</td>
                  <td class="text-right">{{ currFormat(show.onlineTicketRevenue || 0) }}</td>
                  <td class="text-right">{{ currFormat(show.offlineTicketRevenue || 0) }}</td>
                  <td class="text-right">{{ currFormat((show.onlineTicketRevenue || 0) + (show.offlineTicketRevenue || 0)) || '0.00' }}</td>
                  <td class="text-right">{{ currFormat(show.onlineFnbRevenue || 0) }}</td>
                  <td class="text-right">{{ currFormat(show.offlineFnbRevenue || 0) }}</td>
                  <td class="text-right">{{ currFormat((show.onlineFnbRevenue || 0) + (show.offlineFnbRevenue || 0)) || '0.00' }}</td>
                  <td class="text-right">{{ currFormat((show.onlineTicketRevenue || 0) + (show.onlineFnbRevenue || 0)) || '0.00' }}</td>
                  <td class="text-right">{{ currFormat((show.offlineTicketRevenue || 0) + (show.offlineFnbRevenue || 0)) || '0.00' }}</td>
                  <td class="text-right">{{ currFormat((show.onlineTicketRevenue || 0) + (show.onlineFnbRevenue || 0) + (show.offlineTicketRevenue || 0) + (show.offlineFnbRevenue || 0)) || '0.00' }}</td>

                </tr>
              </template>
              <tr class="bg-lightgrey font-weight-bold">
                <td class="text-left" >Total</td>
                <td class="text-right">{{ grandTotal.totalAdmitsForTicketOnline }}</td>
                <td class="text-right">{{ grandTotal.totalAdmitsForTicketOffline }}</td>
                <td class="text-right">{{ grandTotal.totalAdmitsForTicketOffline + grandTotal.totalAdmitsForTicketOnline }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenuesForTicketOnline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenuesForTicketOffline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenuesForTicketOffline + grandTotal.totalRevenuesForTicketOnline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenueForFnbOnline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenueForFnbOffline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenueForFnbOffline + grandTotal.totalRevenueForFnbOnline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenuesForTicketOnline + grandTotal.totalRevenueForFnbOnline) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.totalRevenuesForTicketOffline + grandTotal.totalRevenueForFnbOffline) }}</td>
                <td class="text-right">{{ 
                currFormat(grandTotal.totalRevenuesForTicketOffline +
                 grandTotal.totalRevenueForFnbOffline +
                  grandTotal.totalRevenuesForTicketOnline +
                   grandTotal.totalRevenueForFnbOnline)
                   }}
                   </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="totalRevenueData.length == 0" style="overflow-x: scroll; width: auto !important">
          <table class="swc-report-table" border="1">
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                  <th>{{ $tc("Location") }}</th>
                <th>{{ $t("Admits Online") }}</th>
                <th>{{ $tc("Admits Offline") }}</th>
                <th>{{ $tc("Admits Total") }}</th>
                <th>{{ $t("Bo Revenue Online") }}</th>
                <th>{{ $t("Bo Revenue Offline") }}</th>
                <th>{{ $t("Bo Revenue Total") }}</th>
                <th>{{ $t("Fnb Revenue Online") }}</th>
                <th>{{ $t("Fnb Revenue Offline") }}</th>
                <th>{{ $t("Fnb Revenue Total") }}</th>
                <th>{{ $t("Total Revenue Online") }}</th>
                <th>{{ $t("Total Revenue Offline") }}</th>
                <th>{{ $t("Total Revenue") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="12">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import NewReportService from "../../../services/NewReportService";
import FnBReportService from "@/services/FnBReportsService";
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    NoRecords,
  },
  computed: {},
  data() {
    return {
      showNegative: "Y",
      showNegativeWatchers: "Y",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      selectedCinema: [],
      totalRevenueData: [],
      fromDate: new Date(),
      toDate: new Date(),
      disabledAfter: new Date(),
      grandTotal: {},
      disabledDates: {
        from: "",
      },
    };
  },
  beforeMount() {
 
    this.fromDate = new Date();
  },
  watch: {

  },

  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },

  methods: {
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = [{ cine_id: 0, cine_name: "All Cinema" }, ...data.Records];
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelectCinema: function (event) {
      this.selectedCinema = event;

      if (event.length > 0) {
        if (event[event.length - 1].cine_name == "All Cinema") {
          this.dropDown.cinemas = this.dropDown.cinemas.map(cinema => ({
            ...cinema,
            $isDisabled: true
          }));
          // Enable "All Cinema" option
          const allCinema = this.dropDown.cinemas.find(cinema => cinema.cine_name == "All Cinema");
          if (allCinema) {
            allCinema.$isDisabled = false;
          }
          console.log("1");
        } else {
          this.dropDown.cinemas = this.dropDown.cinemas.map(cinema => ({
            ...cinema,
            $isDisabled: cinema.cine_name == "All Cinema"
          }));
          console.log("2");
        }
      } else {
        this.dropDown.cinemas = this.dropDown.cinemas.map(cinema => ({
          ...cinema,
          $isDisabled: false
        }));
        console.log("3");
      }
    },
    async getTotalRevenueData({ isPdf, isExcel }) {
      let loader = this.$loading.show();
      try {
        let cinemaIds = [];

        if (this.selectedCinema.length) {
          if (this.selectedCinema[0].cine_id === 0) {

            cinemaIds = this.CinemasCopy.map(cinema => cinema.cine_id);
          } else {
            cinemaIds = this.selectedCinema.map(cinema => cinema.cine_id);
          }
        }

        let payload = {
          cinema_id: cinemaIds,
          cinema_name: this.dropDown.selectedCinema.map(x =>x.cine_name) || [],
          cinema_address: this.dropDown.selectedCinema.map(x =>x.cine_address) || [],
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdf,
          isExcel,
        }
        let response = await NewReportService.getOfflineOnlineTotalRevenueReport(payload);

        const { data } = response;
        if (data.status && data.Records.length) {
          this.totalRevenueData = [...data.Records ]
          console.log("this.totalRevenueData",this.totalRevenueData)
          this.grandTotal = data.grandTotal
          if (data.pdfPath && isPdf == "Y") {
            window.open(data.pdfPath, "_blank");
          }
          if (data.excelPath && isExcel == "Y") {
            window.open(data.excelPath, "_blank");
          }
        }
        else {
          this.$toasted.show(data.message);
        }

      }
      catch (error) {
        console.log(error)
      }
      finally {
        if (loader) {
          loader.hide()
        }
      }
    }

  },
};
</script>

<style scoped>
.left-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-bottom: 1px solid black !important;
  border-right: 0 !important;
}

.right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}

.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.borderOnly {
  border-left: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  border-right: 1px !important;
}

.no_border {
  border: 0px !important;
}

.concession_blue {
  background-color: #c5d6f0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/offlineOnlineTotalRevenueReport.vue